import { useState } from 'react';
import classNames from 'classnames';
import Image from 'next/image';
import Skeleton from 'react-loading-skeleton';

import { ActiveLink } from '@/ui/index';

import styles from './ServicesGrid.module.scss';

const Service = ({ item, popular = false }) => {
  const [isImageLoaded, setIsImageLoaded] = useState(false);

  return (
    <div
      className={classNames([styles.service, { [styles.popular]: popular }])}
      itemScope
      itemType='https://schema.org/Article'
    >
      <div className={styles.image}>
        {!isImageLoaded && <Skeleton width={90} height={90} />}
        <Image
          className={styles.imageMain}
          src={item?.image}
          alt={item?.title}
          title={item?.title}
          width={90}
          height={90}
          loading='lazy'
          onLoadingComplete={() => setIsImageLoaded(true)}
          style={{
            visibility: isImageLoaded ? 'visible' : 'hidden',
          }}
        />
      </div>
      <div className={styles.content}>
        <div className={styles.title}>{item?.title}</div>
        <div className={styles.text}>{item?.description}</div>
      </div>
      <div className={styles.button}>
        <ActiveLink href={item?.slug}>
          <a
            title={item?.button_text}
            aria-label={item?.button_text}
            className={styles.link}
          >
            {item?.button_text}
            <span className={styles.arrow}>
              {!isImageLoaded && <Skeleton width={24} height={24} />}
              <Image
                src='/assets/ArrowRightNew.svg'
                alt='arrow icon'
                title='Arrow Icon'
                width={24}
                height={24}
                onLoadingComplete={() => setIsImageLoaded(true)}
                style={{
                  visibility: isImageLoaded ? 'visible' : 'hidden',
                }}
              />
            </span>
          </a>
        </ActiveLink>
      </div>
    </div>
  );
};

export default Service;
